import React, { Component } from 'react';

class InstaGallery extends Component {
	render() {
		return (
			<section className="home__insta">
				<div className="container-fluid">
					<h1>@lovefromyours <img src="images/home/insta-icon.png" alt="" /></h1>
					<div className="row">
						<div className="col-lg-3 col-6">
							<img className="mw-100" src="images/home/insta1.png" alt="" />
						</div>
						<div className="col-lg-3 col-6">
							<img className="mw-100" src="images/home/insta2.png" alt="" />
						</div>
						<div className="col-lg-3 col-6">
							<img className="mw-100" src="images/home/insta3.png" alt="" />
						</div>
						<div className="col-lg-3 col-6">
							<img className="mw-100" src="images/home/insta4.png" alt="" />
						</div>
					</div>
				</div>
			</section>
		);
	}
}


export default InstaGallery